import {RouteLocationRaw, RouteRecordRaw, useRoute} from "vue-router";
import {LOCALE_CATEGORIES} from "@/assets/locales/categories.ts";
import { customAsyncComponent } from "@/functions/customAsyncComponent";
import { WorkspaceId } from "@/sdk";

export function getAccountTermsOfServiceRouteRecord():RouteRecordRaw{
  return {
    name: 'account_tos',
    path: 'terms-of-service',
    component: customAsyncComponent(async () => import('./views/TermsOfServiceView.vue')),
      
    meta: {
      accountNav: true,
      localeCategories: [
        LOCALE_CATEGORIES.TOS_GLOBAL,
        LOCALE_CATEGORIES.MY_ACCOUNT,
        LOCALE_CATEGORIES.ERRORS,
      ]
    }
  }
}

export function getAccountTermsOfServiceRouteLocation(workspaceId: WorkspaceId):RouteLocationRaw{
  return { name: 'account_tos', params:{workspaceId} }
}